<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-checkbox
        v-model="showCookiePolicy"
        :label="$t('settings.formTerms.showCookiePolicy')"
        hide-details
      />
    </v-flex>
    <v-flex xs12 v-if="showCookiePolicy" style="padding-top: 10px;">
      <h5>{{ $t('settings.formTerms.cookiePolicy') }}:</h5>
    </v-flex>
    <v-flex xs12 v-if="showCookiePolicy">
      <translate
        v-model="cookiePolicy"
        :languages="Languages"
        :label="$t('settings.formTerms.cookiePolicy')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
        type="richText"
      />
    </v-flex>
    <v-flex xs12>
      <v-checkbox
        v-model="showPrivacyPolicy"
        :label="$t('settings.formTerms.showPrivacyPolicy')"
        hide-details
      />
    </v-flex>
    <v-flex xs12 v-if="showPrivacyPolicy" style="padding-top: 20px;">
      <h5>{{ $t('settings.formTerms.privacyPolicy') }}:</h5>
    </v-flex>
    <v-flex xs12 v-if="showPrivacyPolicy">
      <translate
        v-model="privacyPolicy"
        :languages="Languages"
        :label="$t('site.subtitle')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
        type="richText"
      />
    </v-flex>
    <v-flex xs12
      style="padding-bottom: 20px;"
    >
      <div
        class="text-right pt-2"
      >
        <v-btn class="mr-4" @click="handleGetData">{{ $t('common.cancel') }}</v-btn>
        <v-btn dark :color="enterpriseColor" @click="handleSave">{{ $t('common.save') }}</v-btn>
      </div>
      <v-snackbar
        top
        right
        v-model="snackbar"
        :timeout="timeout"
        :color="messageColor"
      >
        {{ message }}
        <v-btn
          color="black"
          text
          @click="snackbar = false"
        >
          {{ $t('common.close') }}
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils.js'
  import Translate from '@/components/Translate'
  export default {
    components: {
      Translate,
    },
    props: {
      workspaceID: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      loading: false,
      showCookiePolicy: false,
      cookiePolicy: { es: ''},
      showPrivacyPolicy: false,
      privacyPolicy: { es: ''},
      snackbar: false,
      message: '',
      messageColor: 'success',
      timeout: 3000,
    }),
    computed: {
      ...mapState('app',['Languages', 'enterpriseID', 'BGColor', 'Logo', 'Carousel', 'enterpriseColor', 'Languages', 'DefaultLocale']),
      allLanguages () {
        return utils.getAllLanguages()
      }
    },
    watch: {
    },
    mounted () {
      this.handleGetData()
    },
    methods: {
      handleGetData () {
        this.showCookiePolicy = false
        this.cookiePolicy = { es: ''}
        this.showPrivacyPolicy = false
        this.privacyPolicy = { es: ''}

        this.loading = true
        api.getAll(`enterprises/terms/${this.workspaceID}/`, true, 1, 100000, '')
          .then(response => {
            if (!response || response.length === 0) return
            const aux = response.shift()
            this.showCookiePolicy = aux.ShowCookiePolicy ? true : false
            this.cookiePolicy = aux.CookiePolicy ? JSON.parse(aux.CookiePolicy) : { es: ''}
            this.showPrivacyPolicy = aux.ShowPrivacyPolicy ? true : false
            this.privacyPolicy = aux.PrivacyPolicy ? JSON.parse(aux.PrivacyPolicy) : { es: ''}

            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
      },
      handleChangeIsModified () {

      },
      handleSave () {
        const body = {
          WorkspaceID: this.workspaceID,
          ShowCookiePolicy: this.showCookiePolicy,
          CookiePolicy: this.cookiePolicy,
          ShowPrivacyPolicy: this.showPrivacyPolicy,
          PrivacyPolicy: this.privacyPolicy,
        }

        api.updateItem('enterprises', `terms/${this.workspaceID}`, body)
          .then(response => {
            if (!response.data.error) {
              this.message = this.$t('settings.colors.messages.update')
              this.messageColor = 'success'
              this.snackbar = true
            }
          })
          .catch(error => {
            console.log('error', error)
          })
      },
    },
  }
</script>
